<template lang="pug">
f7-popup(:opened='opened')
  f7-page
    popup-navigation-bar(title='レッスンの流れ | スポともダンス', @close='$emit("close")')
    background
      .lesson-flow-page
        iframe(src='https://dance-lp.spotomo.com/flow/index.html')
</template>

<style lang="scss" scoped>
.lesson-flow-page {
  margin-top: 56px;
  height: calc(100vh - 56px);
  overflow: hidden;
  iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
}
</style>

<script>
export default {
  props: {
    opened: { type: Boolean },
  },
}
</script>
